import { inject, Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse, HttpContextToken } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ToastService } from 'src/app/services/toast/toast-service';
import { SpinnerService } from '../spinner/spinner-service';

export const SKIP_GLOBAL_ERROR = new HttpContextToken<boolean>(() => false);
@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService implements HttpInterceptor {
  private toastService = inject(ToastService);
  private spinner = inject(SpinnerService);
  private router = inject(Router);

  constructor() {}

  private extractErrorMessage(error: any): string {
    if (!error) return 'Something went wrong';
    const candidates = [
      error?.error?.data,
      error?.error?.Message,
      error?.error?.message,
      error?.Message,
      error?.message,
      error?.error?.data?.Message
    ];
    for (const c of candidates) {
      if (Array.isArray(c) && c.length) {
        return c.join('\n');
      }
      if (typeof c === 'string' && c.trim()) {
        return c;
      }
    }
    return 'Something went wrong';
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const skipGlobalError = req.context.get(SKIP_GLOBAL_ERROR);
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        const loginUnauthorized = error.status === 401 && this.router.url.includes('/login');
        if (skipGlobalError || loginUnauthorized) {
          return throwError(() => error);
        }

        this.toastService.error(this.extractErrorMessage(error));
        return throwError(() => error);
      })
    );
  }
}
